import React from 'react';
import {GridColDef, GridRenderEditCellParams, useGridApiContext} from '@mui/x-data-grid-pro';
import {Stack} from '@mui/material';

import {ColumnProps} from '@utils/table/columnTypes.table';
import {Array} from '@utils/extensions/array.extension';
import TextFieldComponent from '@components/inputs/textField/TextField.component';

type InputColumnComponentProps = GridRenderEditCellParams

const InputColumnComponent = (props: InputColumnComponentProps) => {
  const {id, field, value} = props;

  const apiRef = useGridApiContext();

  return (
    <Stack flex={1}>
      <TextFieldComponent
        placeholder="-"
        handleChange={(newValue) => apiRef.current.setEditCellValue({id, field, value: newValue})}
        value={value ?? ''}/>
    </Stack>
  );
};

interface InputColumnProps extends ColumnProps {
  disabled?: boolean;
}

export const COLUMN_TYPE_INPUT = (props: InputColumnProps): GridColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  flex: props.fullWidth ? 1 : undefined,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  editable: !props.disabled,
  renderCell: (params) => {
    return (
      <Stack flex={1}>
        <TextFieldComponent
          readOnly
          placeholder="-"
          value={params.value}/>
      </Stack>
    );
  },
  renderEditCell: (params) => {
    return (
      <InputColumnComponent {...params}/>
    );
  },
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});